export const GET_TRANSACTION_CODES = '/get_transaction_codes';
export const GET_SINGLE_TRANSACT_CODE = '/get_single_transact_code';
export const UPDATE_TRANSACTION_CODE = '/update_transaction_code';
export const CREATE_TRANSACTION_CODE = '/create_transaction_code';
export const REMOVE_TRANSACTION_CODE = '/remove_transaction_code';

export const FORM_DATA = {
  name: '',
  code: '',
  sequence: '',
  is_active: '',
  is_land: '',
  is_building: '',
  is_machinery: '',
};
